import { CREHANA_BASE_URL_PRD, CREHANA_BASE_URL_QA } from '@crehana/constants';

/** This function return the base url based process.env with country prefix if @prefix
 * param is defined. The returned url comes always without / at the end
 */
const getBaseUrl = () => {
  let baseUrl = CREHANA_BASE_URL_PRD;

  if (process.env.NODE_ENV === 'development') {
    baseUrl = `http://localhost:3000`;
  }

  if (process.env.NODE_ENV === 'test') {
    baseUrl = CREHANA_BASE_URL_QA;
  }

  return baseUrl;
};

export default getBaseUrl;
